// TODO(ROI-1295): point at the RobVision page (robflow/robvision/intro/)
// once it exists on the hosted docs.
export const ROBDOCS_URL = 'https://docs.rob.co/';

// Live once the eng-3516 docs are released.
export const ROBDOCS_LABELING_URL = `${ROBDOCS_URL}robflow/robvision/labeling/`;

export function openRobDocs(url: string = ROBDOCS_URL): void {
  window.open(url, '_blank', 'noopener');
}
